enum AsyncActionStatus {
    FAILED = 0,
    IDLE,
    LOADING
}

export default AsyncActionStatus